import { ApplicationState } from "../index";

export function getById(id: string) {
  return (state: ApplicationState) =>
    state.userGroup.data?.data?.find((x) => x.id === id);
}
